import axios from "axios";
import { SaleStatusType } from "enums";
import {
  ApplyItemDetailModel,
  ApplyItemListModel,
  ApplyItemSearchOptions,
} from "models";
import { IAPIResult } from "models/interfaces";
import { Utils } from "utils";

/** 自社商品の検索 */
export async function search(options: ApplyItemSearchOptions) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult<ApplyItemListModel>>(
    "/api.d/v1/ec/item/own-search",
    options
  );

  return response.data;
}

/** 自社商品の名前一覧 */
export async function list(item_name?: string) {
  item_name = item_name ?? "";
  // await Utils.sleep(300);
  const response = await axios.get<
    IAPIResult<{ item_cd: string; item_name: string }[]>
  >("/api.d/v1/ec/item/list", {
    params: {
      item_name,
    },
  });
  return response.data;
}

export async function preCheckCreate(data: ApplyItemDetailModel) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/apply-item/creation-check",
    data
  );
  return response.data;
}

export async function create(data: ApplyItemDetailModel) {
  // await Utils.sleep(300);
  const response = await axios.post<IAPIResult>(
    "/api.d/v1/ec/apply-item/create",
    data
  );
  return response.data;
}

export async function preCheckUpdate(data: ApplyItemDetailModel) {
  // await Utils.sleep(300);
  const response = await axios.post<
    IAPIResult<{ is_approval_required: boolean }>
  >("/api.d/v1/ec/apply-item/updation-check", data);
  return response.data;
}

export async function update(data: ApplyItemDetailModel) {
  // await Utils.sleep(300);

  Utils.addDeleteFlag(data.apply_item_main_image);
  Utils.addDeleteFlag(data.apply_item_append_pdf);

  const response = await axios.put<IAPIResult>(
    "/api.d/v1/ec/apply-item/update",
    data
  );
  return response.data;
}

export async function updateSaleStatus(params: {
  item_cd: string;
  sale_status: SaleStatusType;
}) {
  // await Utils.sleep(300);
  const response = await axios.put<IAPIResult<ApplyItemDetailModel>>(
    "/api.d/v1/ec/item/sale-status-update",
    params
  );
  return response.data;
}

export async function detail(params: {
  item_cd: string;
}): Promise<IAPIResult<ApplyItemDetailModel>> {
  // await Utils.sleep(300);
  const response = await axios.get<IAPIResult<ApplyItemDetailModel>>(
    "/api.d/v1/ec/apply-item/detail",
    { params: params }
  );

  if (response.data?.data) {
    const data = response.data.data;
    if (!data.apply_item_cd) {
      data.apply_item_cd = params.item_cd;
    }
    if (!data.apply_item_main_image) {
      data.apply_item_main_image = {
        file_name: "",
        image_url: "",
      };
    }
    if (!data.apply_item_append_pdf) {
      data.apply_item_append_pdf = {
        file_name: "",
        image_url: "",
      };
    }
    if (!data.apply_item_sub_image) {
      data.apply_item_sub_image = [];
    }
    if (!data.apply_tag) {
      data.apply_tag = [];
    }
    if (!data.apply_recommend_item) {
      data.apply_recommend_item = [];
    }
  }
  return response.data;
}

export async function del(params: { apply_item_cd: string }) {
  // await Utils.sleep(300);
  const response = await axios.delete("/api.d/v1/ec/apply-item/delete", {
    data: params,
  });
  return response;
}

export async function csvExport(options: ApplyItemSearchOptions) {
  // await Utils.sleep(300);
  const response = await axios.post<BlobPart>(
    "/api.d/v1/ec/item/own-csv-export",
    options,
    {
      responseType: "blob",
    }
  );
  return response;
}
